import request from '@/utils/request';

//会员整体变化
export function getStatistics() {
  return request('/dashboard-report/ugc/queryOverallChangeReport', {
    method: 'GET',
  });
}
//订单金额趋势
export function getOrder(values) {
  return request('/dashboard-report/ugc/querySalesTrendReport', {
    method: 'GET',
    params: values,
  });
}
//型动值变化趋势
export function queryTrendActionValueChangesReport(values) {
  return request('/dashboard-report/ugc/queryTrendActionValueChangesReport', {
    method: 'GET',
    params: values,
  });
}
//查询新会员购买报表
export function queryNewMemberBuyReport(values) {
  return request('/dashboard-report/ugc/queryNewMemberBuyReport', {
    method: 'GET',
    params: values,
  });
}
// 积分增长、消耗趋势
export function getPoint() {
  return request('/dashboard-report/ugc/queryPointTrendReport', {
    method: 'GET',
    // params: values,
  });
}
// 年龄分布
export function getAge() {
  return request('/dashboard-report/ugc/queryAgeDistributionReport', {
    method: 'GET',
    // params: values,
  });
}
// 来源分布
export function getSource() {
  return request('/dashboard-report/ugc/queryChannelDistributionReport', {
    method: 'GET',
    // params: values,
  });
}
// 活跃会员
export function getActiveUser() {
  return request('/dashboard-report/ugc/queryActiveMemberReport', {
    method: 'GET',
    // params: values,
  });
}
// 等级分布
export function getGrade() {
  return request('/dashboard-report/ugc/queryLevelDistributionReport', {
    method: 'GET',
    // params: values,
  });
}
// 会员变化趋势
export function getCount() {
  return request('/dashboard-report/ugc/queryMemberTrendReport', {
    method: 'GET',
    // params: values,
  });
}
// 字典code对应汉字
export function getDict() {
  return request('/common/dict?dict_type=customer_source', {
    method: 'GET',
    // params: values,
  });
}
